import React, { useContext, useEffect, useState } from "react";
// another components
import { ModalVisualizarDocumentos } from "../../../../components/Generales/ModalVisualizarDocumentos";
// styled components
import { Table, Empty, Button, Modal, Radio, Input, message } from "antd";
// models
import { PostulacionModel } from "../../../../models/PostulacionesModel/postulacion.model";
// icons
import { EyeOutlined, DownloadOutlined} from "@ant-design/icons";
import { openNotification } from "../../../../utils/Notifactions";
import { ModalAceptar } from "../../components/ModalAceptar";
import apiParticipantes from "../../../../api/Participantes/api-participantes";
import DocumentosService from "../../../../api/Documentos/api-documentos";
import apiDocumentos from "../../../../api/Documentos/api-documentos";
import { TemplateContext } from "../../../../utils/template_context";
import { DownloadFile } from "../../../../utils/DownloadFile";
import apiConvocatorias from "../../../../api/Convocatorias/api-convocatorias";
import moment from "moment";
import getStorageUser from "../../../../middlewares/GetStorageUser"
import { JuradosService } from "../../../../api/Jurados/api-jurados";

import { momentCierre } from '../../../../utils/horaCierre';

interface IProps {
  postulacion: PostulacionModel;
  setPostulacion: any;
  allPostulaciones: Array<PostulacionModel>;
  setAllPostulaciones: any;
  descargarArchivo: any;
  lineasConvocatoria: any;
  isBeps?: boolean;
}

const coloresEstado: any = {
  "Sin Revisar": "black",
  Aceptado: "#00904C",
  Rechazado: "#DB2828",
  Subsanar: "#F28C02",
  Subsanado: "#6435C9",
};

export const InformacionPostulacionSubsanar: React.FC<IProps> = (
  props: IProps
) => {

  const [modalDocumento, setModalDocumento] = useState<boolean>(false);
  const [documento, setDocumento] = useState<string>("");
  const [nombreDocumento, setNombreDocumento] = useState<string>("");
  const [tipodocumento] = useState<string>("");
  const [indexDocumento, setIndexDocumento] = useState<number>(0);
  const [evento, setEvento] = useState<any>({});
  const [user, setUser] = useState<any>({});
  const [aceptarModalDocumento, setAceptarModalDocumento] =
    useState<boolean>(false);

  // Estados para Modal Declaración de Residencia
  const [openResidenciaModal, setOpenResidenciaModal] = useState(false);
  const [tipoPersona, setTipoPersona] = useState<string>("");
  const [anosResidencia, setAnosResidencia] = useState<string>("");
  const [direccion, setDireccion] = useState<string>("");
  const [pais, setPais] = useState<string>("");
  const [ciudad, setCiudad] = useState<string>("");
  const [comuna, setComuna] = useState<string>("");
  const [fechaFirma, setFechaFirma] = useState<string>("");
  const [preview, setPreview] = useState<any>();
  const [file, setFile] = useState<any>();
  const [paisResidencia, setPaisResidencia] = useState<string>("");
  const [filenameFirma, setFilenameFirma] = useState<string>("");
  const [isViewOnly, setIsViewOnly] = useState<boolean>(false);
  const fileInputRef = React.useRef<any>(null);
  const juriesServices = new JuradosService();
  const prevTipoPersona = React.useRef<string>("");
  //   functions
  const getUser = async () => {
    try {
      const _user = getStorageUser()
      setUser(_user)
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getUser();
  }, [])

  const aplicarDatosTipo = (tipo: string) => {
    if (tipo === "colombiano" && user) {
      setPaisResidencia("COLOMBIA");
      setDireccion((d: string) => d || user.direccion || "");
      setPais("COLOMBIA");
      setCiudad((c: string) => c || localStorage.getItem("ciudad") || "");
      setComuna((com: string) => com || localStorage.getItem("comuna") || "");
    } else if (tipo === "extranjero") {
      setPaisResidencia("");
      setAnosResidencia((a: string) => a || "");
      setDireccion((d: string) => d || "");
      setPais((p: string) => p || "");
      setCiudad((c: string) => c || "");
      setComuna((com: string) => com || "");
    }
  };

  useEffect(() => {
    if (prevTipoPersona.current !== tipoPersona) {
      prevTipoPersona.current = tipoPersona;
      aplicarDatosTipo(tipoPersona);
    }
  }, [tipoPersona, user]);

  const normalizarTexto = (texto: string) =>
    texto
      .trim()
      .toUpperCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");

  const obtenerFechaFormateada = () => {
    const fechaActual = new Date();
    const meses = [
      "enero", "febrero", "marzo", "abril", "mayo", "junio",
      "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
    ];
    const dia = fechaActual.getDate();
    const mes = meses[fechaActual.getMonth()];
    const anio = fechaActual.getFullYear();
    return `${dia} de ${mes} de ${anio}`;
  };

  const selectFile = (e: any) => {
    const { type } = e.target.files[0];

    if (type !== "image/png" && type !== "image/jpeg") {
      return openNotification({
        titulo: "Error",
        descripcion: "Solo se permiten archivos en formato .png y .jpg",
        placement: "bottomRight",
      });
    }

    const formData = new FormData();
    formData.append("archivo", e.target.files[0]);

    setFile(formData);
    setPreview(URL.createObjectURL(e.target.files[0]));
  };

  const getSignature = async (firma: string) => {
    if (!firma) return;
    if (firma.startsWith('data:image') || firma.startsWith('blob:')) {
      setPreview(firma);
      return;
    }
    try {
      const nombreArchivo = firma.split('/').pop() || firma;
      const data = await apiDocumentos.consultarArchivo(nombreArchivo);
      if (data?.data) {
        const reader = new FileReader();
        reader.readAsDataURL(data.data);
        reader.onloadend = function () {
          setPreview(reader.result as string);
        }
      }
    } catch (error) {
      console.error("Error al obtener la firma:", error);
    }
  };

  const openResidenciaModalHandler = async (datos: any, index: number, viewOnly: boolean = false) => {
    setIsViewOnly(viewOnly);
    setIndexDocumento(index);
    setTipoPersona(datos.tipo_persona_declaracion || "");
    setAnosResidencia(datos.anos_residencia || "");
    setDireccion(datos.direccion || "");
    setPais(datos.pais || "");
    setCiudad(datos.ciudad || "");
    setComuna(datos.comuna || "");
    setFechaFirma(datos.fecha_firma || "");

    // Cargar firma existente si la hay
    if (datos.firma_declaracion) {
      setFilenameFirma(datos.firma_declaracion);
      getSignature(datos.firma_declaracion);
    } else {
      // Intentar cargar la firma del perfil del jurado como respaldo
      const jury = await juriesServices.getJuryByDocNumber(user.documento);
      if (jury?.[0]?.firma) {
        setFilenameFirma(jury[0].firma);
        getSignature(jury[0].firma);
      }
    }
    setOpenResidenciaModal(true);
  };

  const validarCampos = (): string | null => {
    if (!preview) return "Debe actualizar la firma";
    if (!tipoPersona) return "Debe seleccionar el tipo de persona";
    if (!direccion?.trim()) return "Debe ingresar la dirección";
    if (!pais?.trim()) return "Debe ingresar el país";
    if (!ciudad?.trim()) return "Debe ingresar la ciudad";
    if (!anosResidencia?.trim()) return "Debe ingresar los años de residencia";
    if (tipoPersona === "extranjero" && parseInt(anosResidencia) < 2) return "Debe ingresar los años de residencia (mínimo 2 años)";
    if (tipoPersona === "colombiano" && normalizarTexto(ciudad || "") === "MEDELLIN" && !comuna?.trim()) return "Debe ingresar la comuna";
    return null;
  };

  const firmar = async () => {
    const errorMsg = validarCampos();
    if (errorMsg) { message.error(errorMsg); return; }

    const fechaActual = obtenerFechaFormateada();
    // Priorizar el nombre de archivo guardado en el documento si no hay archivo nuevo
    let urlFirma = filenameFirma || null;

    if (file) {
      try {
        const data = await apiDocumentos.guardarArchivo(file);
        if (data?.data) {
          urlFirma = data.data;
          await juriesServices.saveSignature(user.documento, data.data);
        }
      } catch (err) {
        console.error(err);
        message.error("Error al guardar la firma");
        return;
      }
    }

    // Seguridad: Nunca guardar un blob o base64 en la base de datos
    if (urlFirma && (urlFirma.startsWith('blob:') || urlFirma.startsWith('data:'))) {
      urlFirma = null;
    }

    const obtenerFechaISO = () => {
      let f = new Date();
      return f.getFullYear() + '-' + ('0' + (f.getMonth() + 1)).slice(-2) + '-' + ('0' + f.getDate()).slice(-2) + ' ' + ('0' + f.getHours()).slice(-2) + ':' + ('0' + f.getMinutes()).slice(-2);
    }

    const docsParaMapear = Array.isArray(props.postulacion.documentos_administrativos)
      ? props.postulacion.documentos_administrativos
      : [];

    const nuevosdocumentos = docsParaMapear.map(
      (doc: any, indexdoc: number) => {
        if (indexDocumento === indexdoc) {
          return {
            ...doc,
            url_anterior: doc.url_participante,
            // Guardamos los datos del formulario en el objeto del documento
            tipo_persona_declaracion: tipoPersona,
            pais_residencia: tipoPersona === "colombiano" ? (paisResidencia || "COLOMBIA") : paisResidencia,
            anos_residencia: anosResidencia,
            direccion: direccion,
            pais: pais,
            ciudad: ciudad,
            comuna: comuna,
            firma_declaracion: urlFirma,
            fecha_firma: fechaActual,
            // Marcamos como subsanado
            url_participante: urlFirma, // Guardamos el nombre del archivo para que sea consultable
            checksubsanable: false,
            checksubsanado: true,
            fecha_subsanado: obtenerFechaISO(),
            subsanado_por: `${user.nombres} ${user.apellidos}`
          };
        }
        return doc;
      }
    );

    try {
      await apiParticipantes.guardarDocumentosAdministrativosPostulacion(
        props.postulacion.id_postulacion,
        nuevosdocumentos
      );

      let estado = "Subsanado";
      if (nuevosdocumentos.filter((d: any) => d.checksubsanable).length > 0) {
        estado = "Subsanar";
      }

      await apiParticipantes.cambiarEstadoPostulacion({
        id_postulacion: props.postulacion.id_postulacion,
        estado: estado,
      });

      const updatedPostulation = {
        ...props.postulacion,
        estado,
        documentos_administrativos: nuevosdocumentos,
      };

      props.setPostulacion(updatedPostulation);

      const newAll = props.allPostulaciones.map((p: any) =>
        p.id_postulacion === props.postulacion.id_postulacion ? updatedPostulation : p
      );
      props.setAllPostulaciones(newAll);

      setOpenResidenciaModal(false);
      message.success("Declaración firmada y enviada correctamente");
    } catch (error) {
      console.error(error);
      message.error("Error al guardar la declaración");
    }
  };
  const AceptarModalDocumento = async () => {
    setAceptarModalDocumento(false);

    const obtenerFecha = () => {
      let fechaActual = new Date();
      let anio = fechaActual.getFullYear();
      let mes = ('0' + (fechaActual.getMonth() + 1)).slice(-2);
      let dia = ('0' + fechaActual.getDate()).slice(-2);
      let hora = ('0' + fechaActual.getHours()).slice(-2);
      let minutos = ('0' + fechaActual.getMinutes()).slice(-2);
      let fechaYHora = anio + '-' + mes + '-' + dia + ' ' + hora + ':' + minutos;
      return fechaYHora
    }

    const formData = new FormData();
    formData.append("archivo", evento.target.files[0]);
    let data = await DocumentosService.guardarArchivo(formData);
    let nuevosdocumentos = props.postulacion.documentos_administrativos.map(
      (doc: any, indexdoc: number) => {
        if (indexDocumento === indexdoc) {
          let anterior = doc.url_participante
          return {
            ...doc,
            url_anterior: anterior,
            url_participante: data.data,
            checksubsanable: false,
            checksubsanado: true,
            fecha_subsanado: obtenerFecha(),
            subsanado_por: `${user.nombres} ${user.apellidos}`
          };
        }
        return {
          ...doc,
        };
      }
    );
    await apiParticipantes.guardarDocumentosAdministrativosPostulacion(
      props.postulacion.id_postulacion,
      nuevosdocumentos
    );
    let estado = "Subsanado";
    let subsanar = nuevosdocumentos.filter((data: any) => data.checksubsanable);
    if (subsanar.length > 0) estado = "Subsanar";
    await apiParticipantes.cambiarEstadoPostulacion({
      id_postulacion: props.postulacion.id_postulacion,
      estado: estado,
    });
    props.setPostulacion({
      ...props.postulacion,
      documentos_administrativos: nuevosdocumentos,
    });
    let newallpostulaciones = props.allPostulaciones.map((post: any) => {
      if (props.postulacion.id_postulacion === post.id_postulacion) {
        return {
          ...post,
          estado,
          documentos_administrativos: nuevosdocumentos,
        };
      }
      return {
        ...post,
      };
    });

    return props.setAllPostulaciones(newallpostulaciones);
  };
  const CancelarModalDocumento = () => {
    setAceptarModalDocumento(false);
  };
  const context = useContext(TemplateContext);
  // columns
  const columnasDocumentaciontecnicaModal: any = [
    {
      title: "No.",
      width: 10,
      render: (datos: any, datos2: any, index: number) => {
        return (
            <span>{index + 1}</span>
        );
      },
    },
    {
      title: "Tipo de documento",
      width: 120,
      fixed: context.device === "md" ? "left" : false,
      render: (datos: any, record: any, index: number) => (
        <div className="row">
          <div className="col-12">
            {datos.tipo_documento || datos.descripcion}
          </div>
        </div>
      ),
    },
    {
      title: "Nombre del documento",
      width: 300,
      render: (datos: any, datos2: any, index: number) => {
        return (
            <span>{datos.url_participante}</span>
        );
      },
    },
    {
      title: (
        <div className="row">
          <div className="col-12 justify-content-center">Estado</div>
        </div>
      ),
      width: 100,
      fixed: context.device === "lg" ? "right" : false,
      render: (datos: any, record: any, index: number) => {
        return (
          <>
            {datos.checkaceptartecnico !== undefined ? (
              <div className="row">
                <div className="col-12 justify-content-center">
                  {datos.checkaceptartecnico === true ? (
                    <span style={{ color: coloresEstado["Aceptado"] }}>
                      Aceptado
                    </span>
                  ) : (
                    <span style={{ color: coloresEstado["Rechazado"] }}>
                      Rechazado
                    </span>
                  )}
                </div>
              </div>
            ) : (
              <div className="justify-content-center">
                <span>Inscrito sin revisar</span>
              </div>
            )}
          </>
        );
      },
    },
    {
      title: (
        <>
          <div className="row">
            <div className="col-12 justify-content-center">Acciones</div>
          </div>
          <div className="row">
            <div className="col-6 justify-content-center">Ver</div>
            <div className="col-6 justify-content-center">Descargar</div>
          </div>
        </>
      ),
      width: 120,
      fixed: context.device === "lg" ? "right" : false,
      render: (datos: any, record: any, index: number) => {
        if (datos.url_documento || datos.url_participante) {
          return (
              <div className="row">
                <div className="col-6 justify-content-center">
                  <EyeOutlined
                    onClick={() => {
                      setModalDocumento(true);
                      setDocumento(datos.url_participante);
                    }}
                  />
                </div>
                <div className="col-6 justify-content-center">
                  <DownloadOutlined
                    onClick={() =>
                      DownloadFile(datos.url_participante)
                    }
                  />
                </div>
              </div>
          );
        }
      },
    },
  ];
  //  columns table documentación técnica
  const columnasDocumentacionadministrativaModal: any = [
    {
      title: "No.",
      width: 40,
      render: (datos: any, datos2: any, index: number) => {
        return (
            <span>{index + 1}</span>
        );
      },
      fixed: context.device === "md" ? "left" : false,
    },
    {
      title: "Tipo de documento",
      width: 380,
      fixed: context.device === "md" ? "left" : false,
      render: (datos: any) => (
        <div className="row">
          <div className="col-12">{datos.descripcion}</div>
        </div>
      ),
    },
    {
      title: (
        <div className="row">
          <div className="col-12 justify-content-center">Estado</div>
        </div>
      ),
      width: 100,
      render: (datos: any, record: any, index: number) => {
        return (
            <div className="row">
              <div className="col-12 justify-content-center">
                {(() => {
                  if (datos.checkaceptar) return <span style={{ color: coloresEstado["Aceptado"] }}>Aceptado*</span>;
                  if (datos.checkcancelar) return <span style={{ color: coloresEstado["Rechazado"] }}>Rechazado</span>;
                  if (datos.checksubsanable) return <span style={{ color: coloresEstado["Subsanar"] }}>Subsanar</span>;
                  if (datos.checksubsanado) return <span style={{ color: coloresEstado["Subsanado"] }}>Subsanado</span>;
                  return <span style={{ color: coloresEstado["Sin Revisar"] }}>Sin Revisar</span>;
                })()}
              </div>
            </div>
        );
      },
    },
    {
      title: (
        <>
          <div className="row">
            <div className="col-12 justify-content-center">Acciones</div>
          </div>
          <div className="row">
            <div className="col-6 justify-content-center"></div>
            <div className="col-3 justify-content-center">Ver</div>
            <div className="col-3 justify-content-center">Descargar</div>
          </div>
        </>
      ),
      width: 220,
      render: (datos: any, record: any, index: number) => {
        return (
            <div className="row">
              <div className="col-6 justify-content-center">
                {datos.checksubsanable ? (
                  <div className="row">
                    <div className="col-12">
                      <Button
                        onClick={async () => {
                          let convocatoria = await apiConvocatorias.getConvocatoriaById(props.postulacion.convocatoria_id)
                          for (const element of convocatoria.data.fechas) {
                            if (element.clave == "Plazo para subsanar documentos y presentar observaciones") {
                              let fechaActual = moment();
                              if (fechaActual.isBefore(momentCierre(element.valormax)) && fechaActual.isAfter(moment(element.valormin))) {
                                if (datos.descripcion === 'Declaración de Residencia') {
                                  openResidenciaModalHandler(datos, index);
                                } else {
                                  let inputs: HTMLElement =
                                    document.getElementsByClassName(
                                      "inputs-ref-subsanar-mis-postulaciones"
                                    )[index] as HTMLElement;
                                  inputs.click();
                                }
                              } else {
                                return openNotification({
                                  titulo: "Error",
                                  descripcion: `Solo se permiten subsanar en las fechas estipuladas desde ${moment(element.valormin.substring(0, 10)).format("LL")}, hasta ${momentCierre(element.valormax).format("LLL")}`,
                                  placement: "bottomRight",
                                });
                              }
                            }
                          }
                        }}
                        className="no-margin button-azul-ghost font-family-Montserrat-Medium"
                      >
                        Subsanar documento
                      </Button>
                      <input
                        className="inputs-ref-subsanar-mis-postulaciones"
                        type="file"
                        hidden
                        onChange={async (e: any) => {
                          if (e.target.files!.length > 0) {
                            if (e.target.files[0].type === "application/pdf") {
                              const { name } = e.target.files![0];
                              setNombreDocumento(name);
                              setEvento(e);
                              setIndexDocumento(index);
                              return setAceptarModalDocumento(true);
                            }
                            return openNotification({
                              titulo: "Error",
                              descripcion: "Solo se permiten archivos PDF",
                              placement: "bottomRight",
                            });
                          }
                          e.target.value = "";
                        }}
                      />
                    </div>
                  </div>
                ) : (
                  <div className="row">
                    <div className="col-12">
                      <Button
                        onClick={() => {
                          let inputs: HTMLElement =
                            document.getElementsByClassName(
                              "inputs-ref-subsanar-mis-postulaciones"
                            )[index] as HTMLElement;
                          inputs.click();
                        }}
                        className="no-margin button-azul-ghost font-family-Montserrat-Medium"
                        hidden
                      >
                        Subsanar documento
                      </Button>
                      <input
                        className="inputs-ref-subsanar-mis-postulaciones"
                        type="file"
                        hidden
                      />
                    </div>
                  </div>
                )}
              </div>
              <div
                className="col-3 justify-content-center"
                style={{ alignItems: "center" }}
              >
                <EyeOutlined
                  className="font-size-12px"
                  onClick={() => {
                    if (datos.descripcion === 'Declaración de Residencia' && (datos.firma_declaracion || datos.url_participante?.includes('firma_'))) {
                      openResidenciaModalHandler(datos, index, true);
                    } else {
                      setModalDocumento(true);
                      setDocumento(datos.url_participante);
                    }
                  }}
                />
              </div>
              <div
                className="col-3 justify-content-center"
                style={{ alignItems: "center" }}
              >
                {datos.descripcion !== 'Declaración de Residencia' && (
                  <DownloadOutlined
                    className="font-size-12px"
                    onClick={() => DownloadFile(datos.url_participante)}
                  />
                )}
              </div>
            </div>
        );
      },
    },
  ];
  //   columns table enlaces
  const columnaslinksModal = [
    {
      title: "URL",
      width: 260,
      render: (datos: any, record: any, index: number) => {
        return (
          <div className="row">
            <div className="col-12">
              <a target="_blank" href={datos.url}>
                {datos.url}
              </a>
            </div>
          </div>
        );
      },
    },
  ];
  return (
    <>
      <div
        className="row"
        style={{
          paddingRight: "16px",
          paddingLeft: "16px",
          paddingTop: "16px",
          paddingBottom: "16px",
        }}
      >
        <div
          className="col-6 col-md-3 font-size-12px font-family-Montserrat-SemiBold"
          style={{ paddingLeft: "16px" }}
        >
          Nombre del jurado
          {console.log('props.postulacion', props.postulacion)}
        </div>
        <div className="col-6 col-md-9 font-size-12px font-family-Montserrat-Regular">
          {props.postulacion.nombre_participante}
        </div>
        {props.isBeps ? null : (
          <>
            <div
              className="col-6 col-md-3 font-size-12px font-family-Montserrat-SemiBold"
              style={{ paddingLeft: "16px", background: "#F0F6FB" }}
            >
              Tipo de participante
            </div>
            <div
              className="col-6 col-md-9 font-size-12px font-family-Montserrat-Regular"
              style={{ background: "#F0F6FB" }}
            >
              {({"1": "Persona Natural", "2": "Persona Juridica", "3": "Grupo Conformado"} as Record<string,string>)[props.postulacion.tipo_participante] ?? null}
            </div>
            <div
              className="col-6 col-md-3 font-size-12px font-family-Montserrat-SemiBold"
              style={{ paddingLeft: "16px" }}
            >
              Línea
            </div>
            <div className="col-6 col-md-9 font-size-12px font-family-Montserrat-Regular">
              Banco de Jurados
            </div>
            <div
              className="col-6 col-md-3 font-size-12px font-family-Montserrat-SemiBold"
              style={{ paddingLeft: "16px", background: "#F0F6FB" }}
            >
              Expresión:
            </div>
            <div
              className="col-6 col-md-9 font-size-12px font-family-Montserrat-Regular"
              style={{ background: "#F0F6FB" }}
            >
              {props.postulacion.area}
            </div>
            <div
              className="col-6 col-md-3 font-size-12px font-family-Montserrat-SemiBold"
              style={{ paddingLeft: "16px" }}
            >
              Observaciones
            </div>
            <div
              className="col-6 col-md-9 font-size-12px font-family-Montserrat-Regular"
            >
              <strong style={{ fontSize: '1.3em', fontWeight: 'bold' }}>{props.postulacion.observaciones}</strong>
            </div>
          </>
        )}
        {props.postulacion.documentos_tecnicos !== null &&
          props.postulacion.documentos_tecnicos.length > 0 ? (
          <div
            className="col-12 font-family-Montserrat-Regular font-size-13px"
            style={{ paddingTop: "16px", paddingBottom: "1%" }}
          >
            <span className="font-family-Montserrat-SemiBold">
              Documentos Técnicos
            </span>
            <Table
              style={{ borderTop: "1px solid #C4C4C4" }}
              pagination={false}
              columns={columnasDocumentaciontecnicaModal}
              locale={{
                emptyText: (
                  <Empty
                    description="No se han diligenciados datos para está sección"
                    style={{ padding: "50px" }}
                  />
                ),
              }}
              dataSource={props.postulacion.documentos_tecnicos}
            />
          </div>
        ) : null}
        {props.postulacion.documentos_administrativos !== null &&
          props.postulacion.documentos_administrativos.length > 0 ? (
          <div
            className="col-12 font-family-Montserrat-Regular font-size-13px"
            style={{ paddingTop: "16px", paddingBottom: "1%" }}
          >
            <span className="font-family-Montserrat-SemiBold">
              Documentos administrativos
            </span>
            <Table
              style={{ borderTop: "1px solid #C4C4C4" }}
              pagination={false}
              columns={columnasDocumentacionadministrativaModal}
              locale={{
                emptyText: (
                  <Empty
                    description="No se han diligenciados datos para está sección"
                    style={{ padding: "50px" }}
                  />
                ),
              }}
              dataSource={props.postulacion.documentos_administrativos}
            />
          </div>
        ) : null}
        {props.postulacion.links !== null ? (
          <div
            className="col-12 font-family-Montserrat-Regular font-size-13px"
            style={{ paddingTop: "16px", paddingBottom: "1%" }}
          >
            <span className="font-family-Montserrat-SemiBold">
              Enlaces del proyecto
            </span>
            <Table
              pagination={false}
              style={{ paddingTop: "16px" }}
              columns={columnaslinksModal}
              locale={{
                emptyText: (
                  <Empty
                    description="No se han diligenciados datos para está sección"
                    style={{ padding: "50px" }}
                  />
                ),
              }}
              dataSource={props.postulacion.links}
            />
          </div>
        ) : null}
      </div>
      <ModalVisualizarDocumentos
        visualizar={modalDocumento}
        setVisualizar={setModalDocumento}
        state={{ documento: documento }}
        tipo="participante"
      />
      <ModalAceptar
        modal={aceptarModalDocumento}
        AceptarModal={AceptarModalDocumento}
        CancelarModal={CancelarModalDocumento}
        CancelarArchivo={CancelarModalDocumento}
        TipoDocumento={tipodocumento}
        NombreArchivo={nombreDocumento}
      />
      <Modal
        zIndex={2000}
        style={{ top: 20 }}
        visible={openResidenciaModal}
        footer={null}
        width={800}
        maskClosable={true}
        onCancel={() => setOpenResidenciaModal(false)}
        maskStyle={{
          background: "rgba(12, 164, 93, 0.4)",
        }}
        className="modal-postulacion-exitosa"
      >
        <div className="document-wrapper">
          <div id="modal_custom" className="document-page">

            <h3 className="text-center">
              DECLARACIÓN JURAMENTADA DE RESIDENCIA
            </h3>

            <div style={{ marginBottom: "20px" }}>
              <Radio.Group
                value={tipoPersona}
                onChange={(e) => setTipoPersona(e.target.value)}
                style={{ width: "100%" }}
                disabled={isViewOnly}
              >
                <Radio value="colombiano" style={{ display: "block", marginBottom: "10px", whiteSpace: "normal" }}>
                  Persona natural: <strong>colombiano</strong>, residente en Colombia o fuera del país
                </Radio>
                <Radio value="extranjero" style={{ display: "block", whiteSpace: "normal" }}>
                  Persona natural: <strong>extranjero</strong>, con residencia en Colombia durante al menos los últimos dos (2) años
                </Radio>
              </Radio.Group>
            </div>

            <p className="text-justify">
              Señores, <br />
              <strong>Convoctoria de Fomento y Estímulos para el Arte y la Cultura</strong> <br />
              Secretaría de Cultura Ciudadana <br />
              Alcaldía de Medellín <br />
              Distrito de Ciencia, Tecnología e Innovación

            </p>
            <br />
            <p className="text-justify">
              Yo, <strong>{user.nombres} {user.apellidos}</strong>, identificado(a) con{" "}
              <strong> {user.tipo_identificacion?.split('-')[1]}</strong> número{" "}
              <strong> {user.documento}</strong>, manifiesto bajo{" "}
              gravedad de juramento que mi lugar de residencia es
              <Input
                value={pais}
                onChange={(e) => setPais(e.target.value)}
                placeholder="Ingrese país"
                disabled={isViewOnly}
                style={{ display: "inline-block", width: "200px", marginLeft: "10px" }}
              />
              {" "} y lo ha sido durante los
              últimos{" "}
              {tipoPersona === "colombiano" ? (
                <Input
                  type="number"
                  value={anosResidencia}
                  onChange={(e) => {
                    const val = e.target.value;
                    if (Number(val) < 0) return;
                    setAnosResidencia(val);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === '-' || e.key === 'e' || e.key === '+' || e.key === '.') {
                      e.preventDefault();
                    }
                  }}
                  placeholder="Años"
                  disabled={isViewOnly}
                  style={{ display: "inline-block", width: "80px", margin: "0 5px" }}
                />
              ) : (
                <Input
                  type="number"
                  value={anosResidencia}
                  onChange={(e) => setAnosResidencia(e.target.value)}
                  placeholder="Años"
                  min={2}
                  disabled={isViewOnly}
                  style={{ display: "inline-block", width: "80px", margin: "0 5px" }}
                />
              )}{" "}
              años.
            </p>
            <br />
            <p>
              <strong>Dirección: </strong>
              <Input
                value={direccion}
                onChange={(e) => setDireccion(e.target.value)}
                placeholder="Ingrese la dirección"
                disabled={isViewOnly}
                style={{ display: "inline-block", width: "300px", marginLeft: "10px" }}
              />
            </p>
            <p>
              <strong>Ciudad: </strong>
              <Input
                value={ciudad}
                onChange={(e) => setCiudad(e.target.value)}
                placeholder="Ingrese ciudad"
                disabled={isViewOnly}
                style={{ display: "inline-block", width: "200px", marginLeft: "10px" }}
              />
            </p>

            {normalizarTexto(ciudad) === "MEDELLIN" && (
              <div>
                <strong>Comuna: </strong>
                <Input
                  value={comuna}
                  onChange={(e) => setComuna(e.target.value)}
                  placeholder="Ingrese comuna"
                  disabled={isViewOnly}
                  style={{ display: "inline-block", width: "200px", marginLeft: "10px" }}
                />
              </div>
            )}
            <p><strong>Correo electrónico: {user.correo}</strong> </p>
            <p><strong>Teléfono: {user.celular}</strong> </p>

            <br />

            <p className="text-right">
              En constancia, se firma en {fechaFirma || obtenerFechaFormateada()}
              {preview && (preview.startsWith('data:image') || preview.startsWith('blob:')) && (
                <img
                  src={preview}
                  style={{
                    height: "auto",
                    maxHeight: "100px",
                    width: "auto",
                    display: "block",
                    marginLeft: "auto"
                  }}
              alt="Firma"
              />
              )}
            </p>
          </div>
        </div>
        {!isViewOnly && (
          <div className="acciones-documento" style={{ marginTop: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderTop: '1px solid #eee', paddingTop: '15px' }}>
            <div className="accion-firma">
              <span style={{ display: 'block', marginBottom: '5px' }}>
                Actualizar firma:
              </span>

              <input
                ref={fileInputRef}
                type="file"
                onChange={selectFile}
              />
            </div>

            <div className="accion-botones">
              <Button type="primary" onClick={firmar} style={{ background: '#0CA45D', borderColor: '#0CA45D' }}>
                Firmar y Guardar
              </Button>
            </div>
          </div>
        )}

      </Modal>
    </>
  );
};
